// index.js
import CountdownTimer from './CountdownTimer';
export default CountdownTimer;
